(function($) {

var pageId = 'page-team-export',
  page = '#' + pageId;

$(function() {
  $('body')
  .on('click', page + ' .select-all-cal', function(e) {
    e.preventDefault();
    $('.export-calendars input:checkbox').prop('checked', true);
  })
  .on('click', page + ' .select-none-cal', function(e) {
    e.preventDefault();
    $('.export-calendars input:checkbox').prop('checked', false);
  })
  .on('click', page + ' #btn-exec-export', function(e) {
    e.preventDefault();
    var url = $(this).data('url'),
      projectGuids = $('.export-projects')
        .find('input:checked').map(function(){
          return this.value;
        }).get(),
      calendarGuids = $('.export-calendars')
        .find('input:checked').map(function(){
          return this.value;
        }).get();

    if (!projectGuids.length) {
      simple.dialog.message({
        content: "至少选择一个项目备份。"
      });
      return;
    }

    $.ajax({
      type: 'POST',
      url: url,
      data: {
        project_guids: projectGuids,
        calendar_guids: calendarGuids
      },
      success: function(result) {
        $('.link-page-behind:last').trigger('click');
      }
    });
  });
});

})(jQuery);
